import { defHttp as _defHttp } from '@aplus-frontend/axios-core';
import { axiosVuePresent } from '@aplus-frontend/aplus-axios-vue-preset';
import { getLocale } from '@/locales';
import { getApiBaseUrl, getApiPrefix } from './env';
// import { axiosEvent } from '@aplus-frontend/aplus-axios-vue-preset';
// import { useAuthStore } from '@/store/modules/auth';
// import { getToken } from './auth';

export const defHttp = _defHttp({
  apiUrl: getApiBaseUrl(),
  urlPrefix: getApiPrefix()
});

defHttp.use(
  axiosVuePresent({
    locale: getLocale()
  })
);
